const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    desc: '采用高速服务器集群和智能CDN分发技术，确保影片秒开不卡顿，告别缓冲等待，流畅观影始终如一。',
  },
  {
    icon: 'ri-advertisement-line',
    title: '零广告纯净体验',
    desc: '全站无贴片、无弹窗、无插屏广告，从点击到观看全程无打扰，为你守护最纯粹的观影环境。',
  },
  {
    icon: 'ri-4k-line',
    title: '高清画质全覆盖',
    desc: '片库以1080P高清为主，热门大片提供4K超清版本，智能适配网络环境，自动匹配最佳清晰度。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1440px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">平台优势</h2>
          <p className="text-foreground-500 text-sm mt-2">为什么选择八戒电影网</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          {features.map((item) => (
            <div
              key={item.title}
              className="p-6 md:p-7 bg-background-100 rounded-xl border border-background-200/60 text-center group hover:border-primary-500/30 transition-all cursor-default"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-500/15 rounded-2xl group-hover:bg-primary-500/25 transition-colors">
                <i className={`${item.icon} text-primary-400 text-2xl`}></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-100">{item.title}</h3>
              <p className="mt-2 text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}